module.exports = __webpack_public_path__ + "img/member-2.57d774fe.png";